/**
 * hiddenStr
 * @param str
 * @param start
 * @param end
 * @param hide
 * @returns {string}
 */
export function hidden(str, start, end, hide) {
  if (!str) return '';
  return str.substring(0, start) + new Array(hide).fill('*').join('') + str.substring(str.length - end);
}

/**
 * 根据身份证获取性别
 * @param str
 * @returns {string}
 */
export const getSexFromIdCard = function (str) {
  if (!str) return '';
  if (str.length === 18) {
    var sex = str.substring(16, 17);
    return sex % 2 === 1 ? '男' : '女';
  } else {
    return '';
  }
};
/**
 * 根据身份证获取年龄
 * @param str
 * @returns {*}
 */
export const getAgeFromIdCard = function (str) {
  if (!str) return '';
  var y = new Date().getFullYear();
  if (str.length === 18) {
    return (y - str.substring(6, 10)) + '岁';
  } else {
    return '';
  }
};

/**
 * 性别
 * @param str
 * @returns {*}
 */
export function getSex(str) {
  if (!str) return;
  return {m: '男', f: '女', n: ''}[str.toLowerCase()];
}
